import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { RouteParams } from '@/router/type';
import { startProject } from '@/service/serverless-gpu';
import { toBase64 } from '@/utils';
import { Editor } from '@monaco-editor/react';
import { useMutation } from '@tanstack/react-query';
import { Loader2, PackagePlusIcon, PlayIcon } from 'lucide-react';
import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

const ServerlessGPUPlaygroundRequirements = () => {
  const { projectId } = useParams<RouteParams>();
  const [code, setCode] = useState('');
  const editorRef = useRef(null);

  function handleEditorDidMount(editor: any, monaco: any) {
    editorRef.current = editor;
  }

  const handleInstall = () => {
    mutate({
      project_id: projectId!,
      config: {
        mode: 'realtime',
      },
      requirements_content: toBase64(code),
    });
  };

  const { mutate, isPending } = useMutation({
    mutationFn: startProject,
    onSuccess: () => {
      toast.success('Project started successfully');
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div />
        <div className="flex items-center gap-2">
          <Button
            variant={'default'}
            startIcon={
              isPending ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <PackagePlusIcon className="h-4 w-4" />
              )
            }
            onClick={handleInstall}
            disabled={isPending}
          >
            Install
          </Button>
        </div>
      </div>
      <div className="h-[500px] w-full overflow-hidden">
        <Editor
          height="100%"
          width="100%"
          defaultLanguage="text"
          value={code}
          onMount={handleEditorDidMount}
          onChange={(value) => {
            setCode(value!);
          }}
          options={{
            minimap: {
              enabled: false,
            },
            padding: {
              top: 10,
            },
          }}
          // theme="vs-dark"
          className="border-2"
        />
      </div>
    </div>
  );
};

export default ServerlessGPUPlaygroundRequirements;
